<template>
    <asset-crud kind="policy" />
</template>

<script>
    import AssetCrud from './components/AssetCrud'
    export default { name: 'pageAssetPolicyData', components: { AssetCrud } }
</script>
